import { inject, Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Roles } from '../models/authentication/authorization-constants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private authService = inject(AuthService);

  isAdmin(): boolean {
    var roles = this.getRolesFromToken();
    if (roles) return roles.includes(Roles.Admin);
    return false;
  }

  isDriver(): boolean {
    var roles = this.getRolesFromToken();
    if (roles) return roles.includes(Roles.Driver);
    return false;
  }

  isDispatcher(): boolean {
    var roles = this.getRolesFromToken();
    if (roles) return roles.includes(Roles.Dispatcher);
    return false;
  }

  private getRolesFromToken(): string[] {
    var token = this.authService.currentUserValue.accessToken;
    return jwtDecode<{ role: string[] }>(token).role;
  }
}
